export const en = {
    categories: 'Categories:',
    copied: 'Copied',
    'copy-error': 'Copying error',
    description: 'Retargeting lists, keywords',
    'description-keywords': 'keywords',
    'description-retargetings': 'retargeting lists',
    'description-screens': 'advertising platforms',
    'description-user-profile': 'user profile',
    formats: 'Formats:',
    'go-to-edit-group': 'Edit ad group',
    'hide-full-value': 'Hide all criteria',
    'keywords-title': 'Keywords',
    'no-item': 'Not set',
    'no-items': 'Not set',
    operators: 'Operators:',
    regions: 'Regions:',
    'retargeting-title': 'Retargeting lists',
    screens: 'Screens:',
    'screens-title': 'Advertising platforms',
    'show-full-value': 'Show all criteria',
    title: 'Impression criteria',
    'user-profile-title': 'User profile',
    'zone-categories': 'Screen location areas:'
};
